import type { ReactNode } from 'react';

/** Stroke icons from the design export (24×24, currentColor). */
export const iconPaths = {
  burger: <path d="M4 7h16M4 12h16M4 17h16" />,
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
    </>
  ),
  bag: (
    <>
      <path d="M6 8h12l1 13H5L6 8z" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" />
    </>
  ),
  'arrow-right': <path d="M5 12h14M13 6l6 6-6 6" />,
  'arrow-left': <path d="M19 12H5M11 6l-6 6 6 6" />,
  'arrow-long-right': <path d="M4 12h15M14 7l5 5-5 5" />,
  'arrow-back': <path d="M20 12H5M10 7l-5 5 5 5" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  'chevron-left': <path d="M15 5l-7 7 7 7" />,
  'chevron-right': <path d="M9 5l7 7-7 7" />,
  'chevron-down': <path d="M6 9l6 6 6-6" />,
  'chevron-small-right': <path d="M9 6l6 6-6 6" />,
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  'check-bold': <path d="M5 12l5 5 9-10" />,
  play: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M10 8l6 4-6 4z" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 11v5M12 7.8v.2" />
    </>
  ),
  alert: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5v5.5M12 16.2v.3" />
    </>
  ),
  truck: (
    <>
      <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7" />
      <circle cx="7" cy="17.5" r="1.6" />
      <circle cx="17" cy="17.5" r="1.6" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s6-5.4 6-10.5a6 6 0 0 0-12 0C6 15.6 12 21 12 21z" />
      <circle cx="12" cy="10.5" r="2" />
    </>
  ),
  courier: (
    <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7M7 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM17 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
  ),
  mail: <path d="M3.5 6.5h17v11h-17zM3.5 7l8.5 6.5L20.5 7" />,
  phone: (
    <>
      <rect x="6.5" y="2.5" width="11" height="19" rx="2" />
      <path d="M10.5 18.5h3" />
    </>
  ),
  calendar: (
    <>
      <rect x="3.5" y="5" width="17" height="15.5" rx="1" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4" />
    </>
  ),
  gift: (
    <>
      <path d="M3.5 11.5h17v9h-17z" />
      <path d="M2.5 7.5h19v4h-19z" />
      <path d="M12 7.5v13" />
      <path d="M12 7.5c-1.5-3.5-5.5-4.5-6-2s2.5 2 6 2c3.5 0 6.5 0 6-2s-4.5-1.5-6 2z" />
    </>
  ),
  tape: (
    <>
      <circle cx="9" cy="11" r="6" />
      <circle cx="9" cy="11" r="1.8" />
      <path d="M9 17h13v-4h-7" />
      <path d="M12.5 17v-1.5M15.5 17v-2M18.5 17v-1.5" />
    </>
  ),
  card: (
    <>
      <rect x="3" y="5.5" width="18" height="13" rx="1.5" />
      <path d="M3 9.5h18M6.5 15h4" />
    </>
  ),
  qr: (
    <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2v2h-2zM14 18h2v2h-2zM18 18h2v2h-2z" />
  ),
  'care-sort': (
    <>
      <circle cx="6.5" cy="12" r="3.5" />
      <circle cx="17.5" cy="12" r="3.5" />
      <path d="M12 7v10" />
    </>
  ),
  'care-inside-out': (
    <>
      <path d="M8 4L4 7l2 3 2-1v11h8V9l2 1 2-3-4-3c-.5 1.5-2 2.5-4 2.5S8.5 5.5 8 4z" />
      <path d="M10 14a2 2 0 0 0 4 0M13.2 12.6l.8 1.4-1.5.3" />
    </>
  ),
  'care-zip': (
    <>
      <path d="M12 3v11M10 5h4M10 8h4M10 11h4" />
      <rect x="9.5" y="14" width="5" height="6" rx="1.2" />
    </>
  ),
  'care-detergent': (
    <>
      <path d="M10 3h4v3h-4zM9 6h6l2 4v10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V10z" />
      <path d="M8.5 14c1.2.8 2.3.8 3.5 0s2.3-.8 3.5 0" />
    </>
  ),
  'care-no-bleach': (
    <>
      <path d="M12 4l9 16H3z" />
      <path d="M5 6l14 14M19 6L5 20" />
    </>
  ),
  'care-no-sun': (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
      <path d="M4 20L20 4" />
    </>
  ),
  'symbol-wash': (
    <>
      <path d="M3 9l2.4 11h13.2L21 9" />
      <path d="M3 9c1.5-1.6 3-1.6 4.5 0s3 1.6 4.5 0 3-1.6 4.5 0 3 1.6 4.5 0" />
    </>
  ),
  'symbol-bleach': <path d="M12 4l9 16H3z" />,
  'symbol-dry': (
    <>
      <rect x="4" y="4" width="16" height="16" />
      <circle cx="12" cy="12" r="5.5" />
    </>
  ),
  'symbol-iron': (
    <>
      <path d="M3 18h18v-4a5 5 0 0 0-5-5H8.5C6 9 4 12 3 18z" />
      <path d="M10 9V6h8v3" />
    </>
  ),
  'symbol-dryclean': <circle cx="12" cy="12" r="8" />,
  'param-wash': (
    <path d="M4 9l2 11h12l2-11M3 9c1.5-1.6 3-1.6 4.5 0s3 1.6 4.5 0 3-1.6 4.5 0 3 1.6 4.5 0" />
  ),
  'param-temperature': <path d="M10 14V5a2 2 0 0 1 4 0v9a4 4 0 1 1-4 0zM12 10v6" />,
  'param-spin': <path d="M20 12a8 8 0 1 1-2.3-5.6M20 4v4h-4" />,
  'param-dry': <path d="M4 4h16v16H4zM7 4c0 4 10 4 10 0" />,
  'param-iron': <path d="M3 18h18v-4a5 5 0 0 0-5-5H8.5C6 9 4 12 3 18zM10 9V6h8v3" />,
  'param-storage': (
    <path d="M10 5a2 2 0 1 1 2 2v1l-8.6 7.3a1 1 0 0 0 .6 1.7h16a1 1 0 0 0 .6-1.7L12 8" />
  ),
  'param-avoid': <path d="M12 4a8 8 0 1 0 0 16a8 8 0 1 0 0-16zM6.3 6.3l11.4 11.4" />,
} satisfies Record<string, ReactNode>;

export type IconName = keyof typeof iconPaths;
